<template>
    <div>
        <div class="oneRef">
            <div class="row">
                <div class="col-3 col-lg-2">
                    <img v-if="mainImage" :data-src="mainImage" :alt="title" class="lazyload img-fluid">
                </div>
                <div class="col-9 col-lg-10">
                    <strong><span v-if="referenceTitle">{{ referenceTitle }} - </span>{{ title }}</strong>
                    Réf. {{ referenceCode }}

                    <div class="row" v-if="'site.repository.product_reference' === type || 'site.repository.fidelity_gift' === type">
                        <div class="col-lg-5">
                            <div class="prix" v-if="'site.repository.product_reference' === type">
                                {{ (discountedUnitPrice != unitPrice? discountedUnitPrice : unitPrice) | moneyFormat }}
                                <del v-if="discountedUnitPrice != unitPrice">
                                    {{ unitPrice | moneyFormat }}
                                </del>
                                <span class="advantage" v-if="advantageName && discountedUnitPrice != unitPrice">({{ advantageName }})</span>
                            </div>
                            <div class="prix" v-if="'site.repository.fidelity_gift' === type">{{ unitFidelityPoint }} points fidélité</div>
                        </div>
                        <div class="col-lg-7" >
                            <div v-if="'site.repository.product_reference' === type"><ponroy-cart-quantity v-model="quantity"></ponroy-cart-quantity></div>
                            <div v-if="'site.repository.fidelity_gift' === type">
                                <div class="qty form-group row no-gutters">
                                    <label class="col-5 col-lg-4 col-form-label">Quantité </label>
                                    <div class="col-1 col-lg-1">
                                        <span class="form-control float-left">{{ quantity }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-5">
                            <small>
                                <a  href @click="e => edit(e)" v-if="'site.repository.product_reference' === type">Modifier</a>
                                <a href @click="e => remove(e)" >Supprimer</a>
                            </small>
                        </div>
                        <div class="col-7 text-right">
                            <div class="total" v-if="'site.repository.product_reference' === type">{{ total | moneyFormat }}</div>
                            <div class="total" v-if="'site.repository.gift' === type">OFFERT</div>
                            <div class="total" v-if="'site.repository.fidelity_gift' === type">{{ total }} points</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapActions} from 'vuex';
    import Routing from 'routing';

    const CartItem = {
        name: 'ponroy-cart-item',
        props: {
            type: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            reference: {
                type: [Number, String],
                required: true,
            },
            referenceCode: {
                type: String|Number,
                required: true,
            },
            referenceTitle: {
                type: String,
            },
            referenceProduct: {
                type: String,
                required: false,
            },
            unitPrice: {
                type: Number,
            },
            unitFidelityPoint: {
                type: Number,
            },
            discountedUnitPrice: {
                type: Number,
            },
            total: {
                type: Number,
            },
            baseQuantity: {
                type: Number,
            },
            slug: {
                type: String,
            },
            mainImage: {
                type: String,
            },
            advantageName: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                quantity: this.baseQuantity,
            }
        },
        watch: {
            quantity(quantity) {
                const {reference} = this;
                this.update({reference, quantity});
            }
        },
        methods: {
            ...mapActions('cart', [
                'updateCartItem',
                'removeCartItem'
            ]),
            update({reference, quantity}) {
                const payload = {reference, quantity};
                this.updateCartItem(payload);
            },
            remove(e) {
                e.preventDefault();
                const id = this.reference;
                this.removeCartItem({id});
            },
            edit(e) {
                e.preventDefault();
                window.location.href = Routing.generate('site_product_show', { 'id': this.referenceProduct, 'slug' : this.slug });
            }
        }
    };

    export default CartItem;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartItem.vue